// eventi, formati e frasi comuni a lista, dettaglio, schede e codici dei coupon
import moment from 'moment';

// gli eventi del select "Operazione" di Create.vue / Edit.vue, con icona, spiegazione e il campo giorni quando serve
export const EVENTI = {
	REGISTER_USER: {
		label: 'Registrazione utente',
		icona: 'mdi-account-plus-outline',
		quando: 'quando un cliente si registra',
		testo: 'Un coupon di benvenuto per i nuovi utenti li spinge a fare il primo acquisto.',
	},
	ABANDONED_CARTS: {
		label: 'Carrello abbandonato',
		icona: 'mdi-cart-arrow-down',
		quando: 'quando un cliente lascia il carrello senza comprare',
		testo: "Uno sconto a chi ha messo prodotti nel carrello senza completare l'acquisto può riportarlo sul sito e chiudere la vendita.",
		giorni: "Giorni dopo l'abbandono",
	},
	FIRST_PURCHASE: { label: 'Primo acquisto', icona: 'mdi-shopping-outline', quando: 'al primo acquisto del cliente', testo: 'Un coupon al primo acquisto favorisce la fidelizzazione del cliente.' },
	CUSTOMER_LOYALTY: {
		label: 'Fidelizzazione clienti',
		icona: 'mdi-heart-outline',
		quando: 'quando un cliente abituale non compra da un po’',
		testo: 'Ai clienti abituali, un coupon periodico li premia e mantiene vivo il loro interesse per il negozio.',
		giorni: 'Giorni di inattività',
	},
	NEWSLETTER_SUBSCRIPTION: {
		label: 'Iscrizione newsletter',
		icona: 'mdi-email-plus-outline',
		quando: 'quando un cliente si iscrive alla newsletter',
		testo: "Il coupon in cambio dell'iscrizione fa crescere la lista dei contatti.",
	},
	MINIMUM_PURCHASE: {
		label: 'Minimo acquisto',
		icona: 'mdi-cash-plus',
		quando: 'quando un ordine supera la soglia minima',
		testo: 'Un coupon per gli ordini sopra una soglia aumenta il valore medio degli ordini.',
	},
	HAPPY_BIRTHDAY: {
		label: 'Buon compleanno',
		icona: 'mdi-cake-variant-outline',
		quando: 'al compleanno del cliente',
		testo: 'Uno sconto nel giorno del compleanno del cliente fa piacere e porta vendite.',
	},
	REVIEW_ITEM: {
		label: 'Recensione prodotto',
		icona: 'mdi-star-outline',
		quando: "dopo che l'ordine è completato, per invitare a lasciare una recensione",
		testo: 'Un coupon dopo una recensione incentiva il cliente a tornare e comprare ancora.',
		giorni: "Giorni dopo il completamento dell'ordine",
	},
	NEWSLETTER: {
		label: 'Eventi speciali',
		icona: 'mdi-party-popper',
		quando: 'con una newsletter per un evento speciale',
		testo: 'Sconti in occasione di eventi stagionali (Black Friday, Natale…) aumentano le vendite.',
	},
	PRODUCT_PROMOTION: {
		label: 'Promozione prodotti',
		icona: 'mdi-bullhorn-outline',
		quando: 'per promuovere prodotti scelti',
		testo: 'Un coupon aiuta a lanciare prodotti nuovi: i clienti li provano a prezzo scontato. Puoi limitarlo a clienti, brand, categorie o prodotti.',
	},
	PROCESSED_INVENTORY: {
		label: 'Packing list elaborata',
		icona: 'mdi-package-variant-closed',
		quando: 'ogni volta che una packing list viene elaborata',
		testo: 'Il coupon nasce a ogni elaborazione della giacenza e si mette nel pacco: il testo si prepara in Configurazione email, ma non viene spedito, va scaricato e stampato.',
	},
};

export function evento(tipo) {
	return EVENTI[tipo] || { label: tipo || '—', icona: 'mdi-ticket-percent-outline', quando: '', testo: '' };
}

const numero = v => {
	const n = Number(v);
	return v === '' || v === null || v === undefined || isNaN(n) ? null : n;
};

export function euro(v) {
	const n = numero(v);
	return n === null ? '—' : `€ ${n.toFixed(2).replace('.', ',')}`;
}

// "−10%" oppure "−€ 5,00"
export function sconto(c) {
	const n = numero(c && c.discount);
	if (!n) return '—';
	return c.typology === 'percent' ? `−${String(n).replace('.', ',')}%` : `−${euro(n)}`;
}

export function soglia(c) {
	const n = numero(c && c.price);
	return n ? `su ordini da ${euro(n)}` : '';
}

const data = d => (d ? moment(d).format('DD/MM/YYYY') : '');

// periodo della regola e durata dei codici
export function validita(c) {
	const parti = [];
	if (c.start_at && c.finish_at) parti.push(`dal ${data(c.start_at)} al ${data(c.finish_at)}`);
	else if (c.start_at) parti.push(`dal ${data(c.start_at)}`);
	else if (c.finish_at) parti.push(`fino al ${data(c.finish_at)}`);
	const giorni = numero(c.days_expired);
	if (giorni) parti.push(`codice valido ${giorni} ${giorni === 1 ? 'giorno' : 'giorni'}`);
	return parti.join(' · ') || 'sempre';
}

export function formatItemText(item) {
	if (!item) return '';
	const base = `${item?.trans?.name || ''} ${item?.variants?.sku || ''}`;
	const varianti = item?.variants?.variants?.map(v => `${v?.name?.trans || ''}: ${v?.value?.trans || ''}`).join(', ');
	return `${base} ${varianti || ''}`.trim();
}

export function nomeCliente(c) {
	const b = (c && c.buyer) || {};
	return [b.name, b.lastname].filter(Boolean).join(' ') || b.email || '';
}

// la regola in una frase
export function frase(c) {
	const ev = evento(c.event);
	const giorni = numero(c.days);
	let quando = ev.quando ? ev.quando.charAt(0).toUpperCase() + ev.quando.slice(1) : 'Quando scatta la regola';
	if (ev.giorni && giorni) quando += `, dopo ${giorni} ${giorni === 1 ? 'giorno' : 'giorni'}`;
	const cosa = sconto(c) === '—' ? 'un codice sconto' : `un codice da ${sconto(c)}`;
	const condizione = soglia(c) ? ` ${soglia(c)}` : '';
	return `${quando} il cliente riceve ${cosa}${condizione}${c.prefix ? ` (${c.prefix}…)` : ''}.`;
}

// stato di un singolo codice
export function statoCodice(code) {
	if (code.used_at) return { testo: `Usato il ${data(code.used_at)}`, colore: 'primary', icona: 'mdi-check-decagram-outline' };
	if (code.expired_at && moment(code.expired_at).isBefore(moment())) return { testo: 'Scaduto', colore: 'grey', icona: 'mdi-clock-alert-outline' };
	if (!code.active) return { testo: 'Spento', colore: 'grey', icona: 'mdi-pause-circle-outline' };
	return { testo: 'Utilizzabile', colore: 'success', icona: 'mdi-ticket-confirmation-outline' };
}

export function scadenza(code) {
	if (!code.expired_at) return 'nessuna scadenza';
	const m = moment(code.expired_at);
	const giorni = m.clone().startOf('day').diff(moment().startOf('day'), 'days');
	if (giorni < 0) return `scaduto il ${m.format('DD/MM/YYYY')}`;
	if (giorni === 0) return 'scade oggi';
	if (giorni === 1) return 'scade domani';
	return `tra ${giorni} giorni (${m.format('DD/MM/YYYY')})`;
}
